import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Attendance from '@/components/Attendance'
import Login from '@/components/Login'
import Callback from '@/components/Callback'
import ErrorMsg from '@/components/ErrorMsg'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Home',
        auth: true
      }
    },
    {
      path: '/attendance/:title',
      name: 'attendance',
      component: Attendance,
      meta: {
        title: 'Attendance',
        auth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Login',
        auth: false
      }
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
      meta: {
        title: 'Authenticating...',
        auth: false
      }
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorMsg,
      props: true,
      meta: {
        title: 'Error'
        // do not set 'auth' parameter here, as page should work in both
        // situations when user is authenticated and also un-authenticated
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Use the page's router title to name the page
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  // Redirect to the login page if not authenticated
  // for pages that have 'auth: true' set
  if (to.meta && to.meta.auth !== undefined) {
    if (to.meta.auth) {
      if (store.getters.isAuthenticated) {
        next()
      } else {
        router.push({ name: 'login' })
      }
    } else {
      if (store.getters.isAuthenticated) {
        router.push({ name: 'home' })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js